import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { OrganisationService } from '@core/services';

import { ProductType } from '@/organisations/models';

export function isProductActive(product: ProductType): CanActivateFn {
    return (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
        const orgService = inject(OrganisationService);
        const router = inject(Router);
        const org = orgService.activeOrganisation.getValue();
        const isActive = org?.subscriptionTags?.includes(product) ?? true;

        if (!isActive) {
            return router.createUrlTree(['/404']);
        }
        return true;
    };
}
